import { render, staticRenderFns } from "./ProvisionedProfits.vue?vue&type=template&id=167be07f&scoped=true"
import script from "./ProvisionedProfits.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProvisionedProfits.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProvisionedProfits.vue?vue&type=style&index=0&id=167be07f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167be07f",
  null
  
)

export default component.exports